import {Slot} from '@radix-ui/react-slot'
import {InfiniteMovingCards} from '~/design-system/foundations/InfiniteMovingCards'
import {tv} from 'tailwind-variants'

const logoMashVariants = tv({
  slots: {
    scrollerItem:
      'w-auto text-icon-default [&>*:first-child]:h-full [&_*]:!fill-icon-default [&_svg]:h-full',
  },
  variants: {
    hasCaptions: {
      true: {
        scrollerItem: 'min-h-62 md:min-h-84 3xl:min-h-100', // min-height when captions exist
      },
      false: {
        scrollerItem: '', // no height changes when no captions
      },
    },
  },
})

export type Logo = {
  logo: React.ReactNode
  companyName: string
  captionText?: string
}

export type HgLogoMashProps = {
  logos: [Logo, Logo, Logo, Logo, ...Logo[]]
  logoSpacing?: 'default' | 'tighter'
}

export function HgLogoMash(props: HgLogoMashProps) {
  const {logos} = props
  // Even though caption texts are optional, displaying them is all or none
  // so we only display them if all logos have a caption.
  // This is to ensure alignment is correct.
  const everyLogoHasCaptionText = logos.every(logo => logo.captionText)
  const {scrollerItem} = logoMashVariants({hasCaptions: everyLogoHasCaptionText})

  return (
    <InfiniteMovingCards
      items={logos.map((logo, idx) => (
        <div key={idx} className="flex h-full flex-col items-start justify-between">
          <Slot aria-label={logo.companyName}>{logo.logo}</Slot>
          {logo.captionText && everyLogoHasCaptionText && (
            <p className="text-text-subdued arcadia-heading-12">
              {logo.captionText}
            </p>
          )}
        </div>
      ))}
      classNames={{
        scrollerItem: scrollerItem(),
      }}
      itemScrollDurationSeconds={2.5}
      itemGap="s10"
      itemSpacing={props.logoSpacing || 'default'}
    />
  )
}
